import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AdminRoutingModule } from './admin-routing.module';
import { InformationComponent } from './primary/information/information.component';
import { BussnessInformationComponent } from './primary/bussness-information/bussness-information.component';
import { PrimaryAccountComponent } from './primary-account/primary-account.component';
import { BussnessAccountComponent } from './bussness-account/bussness-account.component';
import { AjouterGestionnaireComponent } from './ajouter-gestionnaire/ajouter-gestionnaire.component';
import { DashboradComponent } from './dashborad/dashborad.component';
import { AjouterPartenaireComponent } from './ajouter-partenaire/ajouter-partenaire.component';
import { AjouterSpayComponent } from './ajouter-spay/ajouter-spay.component';
import { AjouterMembreComponent } from './ajouter-membre/ajouter-membre.component';
import { AchatsComponent } from './primary/achats/achats.component';
import { DepotsComponent } from './primary/depots/depots.component';
import { RetraitsComponent } from './primary/retraits/retraits.component';
import { TaxRulesAdminComponent } from './tax-rules-admin/tax-rules-admin.component';

@NgModule({
  declarations: [
    InformationComponent,
    BussnessInformationComponent,
    PrimaryAccountComponent,
    BussnessAccountComponent,
    AjouterGestionnaireComponent,
    DashboradComponent,
    AjouterPartenaireComponent,
    AjouterMembreComponent,
    AjouterSpayComponent,
    AchatsComponent,
    DepotsComponent,
    RetraitsComponent,
    TaxRulesAdminComponent
  ],
  imports: [SharedModule, AdminRoutingModule]
})
export class AdminModule { }
